import { siteUniqueIdIncludes } from "utils";
import { isInScope } from "contexts/orgFilter";

/**
 * Whether a search item matches the term, for both global searches (desktop
 * header and mobile side menu): one place for the searchable fields, so the two
 * cannot drift apart. `term` must already be trimmed and lowercased.
 */
export const searchItemMatches = (item, term) =>
  Boolean(
    item.name?.toLowerCase().includes(term) ||
      item.extra?.toLowerCase().includes(term) ||
      item.cabinetSerial?.toLowerCase().includes(term) ||
      siteUniqueIdIncludes(item, term)
  );

/**
 * Whether a search item may be listed, with the organization filter: in the
 * filter's scope, and of a paid organization. On main the search exists only
 * for a paid active organization and covers only its sites, so the sites of
 * Essential organizations are never found (a super admin's always are).
 */
export const isSearchableInScope = (item, context) =>
  !context.isOrgFilterEnabled ||
  (isInScope(item.organizationGuid, context.filteredOrgGuid) &&
    context.isPaidOrganization(item.organizationGuid));

export const mapSearchItemsToProps = (state) => {
  let searchItems = [];
  for (const s of Object.values(state.sites.byId)) {
    const organizationGuid = s.customer?.customerGuid ?? null;
    searchItems.push({
      name: s.name,
      guid: s.siteGuid,
      type: "site",
      extra: "",
      siteGuid: s.siteGuid,
      uniqueId: s.uniqueId,
      organizationGuid,
      city: s.city,
      country: s.country,
      connectivitytype: s.connectivitytype,
      latitude: s.latitude,
      longitude: s.longitude,
    });
    for (const gw of s.gateways) {
      searchItems.push({
        name: gw.name,
        guid: gw.gatewayGuid,
        type: "gateway",
        extra: gw.macAddress,
        organizationGuid,
        siteInfo: {
          name: s.name,
          guid: s.siteGuid,
          type: "site",
          extra: "",
          siteGuid: s.siteGuid,
          city: s.city,
          country: s.country,
          connectivitytype: s.connectivitytype,
          latitude: s.latitude,
          longitude: s.longitude,
        },
      });

      const gatewayDetails = state.gateways.byId[gw.gatewayGuid];

      for (const dv of gatewayDetails?.devices || []) {
        const name =
          dv.friendlyName && dv.friendlyName !== ""
            ? dv.friendlyName
            : dv.model;
        const extra = dv.friendlyName && dv.friendlyName !== "" ? dv.model : "";

        searchItems.push({
          name: name,
          guid: dv.deviceGuid,
          type: "device",
          extra: extra,
          cabinetSerial: dv.cabinetSerial,
          organizationGuid,
          gatewayInfo: {
            name: gw.name,
            guid: gw.gatewayGuid,
            type: "gateway",
            extra: gw.macAddress,
            siteInfo: {
              name: s.name,
              guid: s.siteGuid,
              type: "site",
              extra: "",
              siteGuid: s.siteGuid,
              city: s.city,
              country: s.country,
              connectivitytype: s.connectivitytype,
              latitude: s.latitude,
              longitude: s.longitude,
            },
          },
        });
      }
    }
  }

  return { searchItems, controllers: state.controllers };
};

export default mapSearchItemsToProps;
